// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__14TPM","title":"AfterBackImages_title__125Jo","images":"AfterBackImages_images__1VMb8"};